export const FORCE_UPDATE_ORDER = 'force_update_order';
export const ADD_ORDER = 'add_order';
export const GET_ALL_ORDERS = 'get_all_orders';
export const SELECT_ORDER = 'SELECT_ORDER';
export const UPDATE_PRODUCT = 'update_product';
export const UPDATE_ORDERS = 'update_orders';
export const UPDATE_ORDER = 'update_order';
export const ORDER_FINISHED = 'order_finished';

